import { useForm } from 'react-hook-form';
import { FormContentIsland, FormTextField, Grid, HookForm, Button } from '@razz-team/ui-web';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormError } from '../../../hooks/useFormError';

import { useAccountUpdateNameMutation } from '../../../api/accounts';
import { ApiAccount } from '../../../openapi';

interface AccountNameFormProps {
  account: ApiAccount;
  onSuccess: () => void;
}

export function AccountNameForm({ account, onSuccess }: AccountNameFormProps) {
  const { t } = useTranslation();
  const form = useForm<{ name: string }>({
    defaultValues: { name: account.name ?? '' },
  });

  const mutation = useAccountUpdateNameMutation({ accountId: account.id });
  useFormError(form, 'name', mutation.error);

  const handleSubmit = useCallback(
    (values: { name: string }) => {
      mutation.mutate(
        { name: values.name },
        {
          onSuccess,
        },
      );
    },
    [mutation, onSuccess],
  );

  return (
    <Grid
      flexDirection="column"
      gap={4}
      component={HookForm}
      form={form}
      onSubmit={handleSubmit}
      size={12}
    >
      <FormContentIsland>
        <FormTextField
          id="name"
          name="name"
          label={t('Account name')}
          fullWidth
          required
          autoFocus
        />
      </FormContentIsland>
      <Button type="submit" size="large" loading={mutation.isPending} fullWidth>
        {t('Update')}
      </Button>
    </Grid>
  );
}
